import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const TRACKING_SURVEY_SCHEMA = Object.freeze({
  IDENTIFIER: '',
});
const RECORD = generateSchema(TRACKING_SURVEY_SCHEMA);
const KEYS: any = generateKeys(TRACKING_SURVEY_SCHEMA);

export class SurveyTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.survey;
  }

  get properties() {
    return this.toJS();
  }
}
